import { createSelector } from "@reduxjs/toolkit";
import { selectViewerPixPolygons } from "../DesignTab/pixpolygonSelectors";
import { selectHttpDevices } from "../DesignTab/devices/deviceSelectors";
import { selectNonPublishedDevices } from "../DesignTab/devices/deviceSlice";
import { selectHttpMcBimCeilingItems } from "../McBim/httpMcBimSelectors";
import { selectMcBimItemsForViewer } from "../McBim/mcbimItemSelectors";

/** Article codes in the current viewer scene, independent of camera position. */
export const selectViewerCompCodes = createSelector(
  [selectViewerPixPolygons, selectMcBimItemsForViewer, selectHttpMcBimCeilingItems,
    selectHttpDevices, selectNonPublishedDevices],
  (polygons, items, ceilings, devices, previews): string[] => {
    const visibleIds = new Set<string>();
    for (const polygon of polygons) {
      if (polygon.opacity === 0) continue;
      visibleIds.add(String(polygon.entityId ?? polygon.id));
    }

    const codes = new Set<string>();
    const add = (id: unknown, compCode: string | null | undefined) => {
      const code = compCode?.trim();
      if (code && id != null && visibleIds.has(String(id))) codes.add(code);
    };
    for (const item of items) add(item._id, item.compCode);
    for (const item of ceilings) add(item._id, item.compCode);
    for (const device of devices ?? []) add(device._id, device.compCode);
    previews.forEach((device, index) => add(device._id ?? `draft-${index}`, device.compCode));
    return [...codes].sort();
  },
);
